import React, { useState } from 'react'
import SignUpForm from './SignUpForm'
import SignInForm from './SignInForm'
import styles from './AuthModal.module.css'

const AuthModal = ({ isOpen, onClose, initialMode = 'signup' }) => {
  const [mode, setMode] = useState(initialMode) // 'signup' | 'signin'

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>

        {mode === 'signup' ? (
          <SignUpForm onSwitchToSignIn={() => setMode('signin')} />
        ) : (
          <SignInForm onSwitchToSignUp={() => setMode('signup')} />
        )}
      </div>
    </div>
  )
}

export default AuthModal